import { LearnersStudentsClassesIndex } from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type IndexProps = {
  classes: Array<LearnersStudentsClassesIndex>
}

export const useIndexProps = () => useProps<IndexProps>()
